import { Injectable } from "@angular/core";
import { ServiceNames } from "@models/service_enums";
import { ApicallService } from "@core-services/apicall.service";
import { BehaviorSubject } from "rxjs";
import { Tradable } from "@models/interfaces/tradable";
import { TradableListService } from "./currency/tradable_list.service";
import { FEATURED_ASSET_API_SLICE } from "@helpers/constants";

@Injectable({
	providedIn: "root"
})
export class FeaturedAssetsService {
	public readonly name: string = ServiceNames.FEATURED_ASSETS;
	private featuredList: BehaviorSubject<Tradable[]> = new BehaviorSubject<Tradable[]>([]);

	public constructor(
		private apicallService: ApicallService,
		private tradableListService: TradableListService
	) {
		this.getApiData();
	}

	private getApiData(): void {
		this.apicallService.get("featured-assets").subscribe(
			(res) =>
				this.featuredList.next(
					res
						.filter((item) => !!this.tradableListService.getItemById(item["asset_id"]))
						.map((item) => this.tradableListService.getItemById(item["asset_id"]))
						.slice(0, FEATURED_ASSET_API_SLICE)
				) // Only returns first 6 of array, slice should be removed once API is ready
		);
	}

	public getListSubject(): BehaviorSubject<Tradable[]> {
		return this.featuredList;
	}
}
